import * as React from "react";
import { Box, Card, Stack, Typography } from "@mui/material";
import type { Node } from "@xyflow/react";
import type { BusinessService, ServiceMap } from "../types";
import { DependenciesPicker } from "./DependenciesPicker";
import { COLORS } from "../theme/theme-options";
import { useMemo } from "react";

export type DependenciesManagerProps = {
  serviceMap: ServiceMap;
  serviceId?: string;
  dependencies: string[];
  dependents: string[];
  onDependenciesChange: (next: string[]) => void;
  onDependentsChange: (next: string[]) => void;
};

export const DependenciesManager: React.FC<DependenciesManagerProps> = ({
  serviceMap,
  serviceId,
  dependencies,
  dependents,
  onDependenciesChange,
  onDependentsChange,
}) => {
  const nodes = useMemo<Node<BusinessService>[]>(() => {
    return serviceMap.nodes.filter((node) => node.id !== serviceId);
  }, [serviceId, serviceMap.nodes]);

  return (
    <Card variant="glass" sx={{ p: 2 }}>
      <Stack spacing={2}>
        <Box>
          <Typography sx={{ fontSize: 16, fontWeight: 700, color: COLORS.grey[100] }}>
            Dependencies
          </Typography>
          <Typography variant="body2" sx={{ color: COLORS.grey[500], mt: 0.4 }}>
            Select services this service depends on.
          </Typography>
        </Box>

        <DependenciesPicker
          id="dependencies-manager-dependencies"
          label="Dependencies"
          serviceMapId=""
          nodes={nodes}
          value={dependencies}
          onChange={onDependenciesChange}
          width="100%"
          disableNew
        />

        <Box>
          <Typography sx={{ fontSize: 16, fontWeight: 700, color: COLORS.grey[100] }}>
            Dependents
          </Typography>
          <Typography variant="body2" sx={{ color: COLORS.grey[500], mt: 0.4 }}>
            Select services that depend on this service.
          </Typography>
        </Box>

        <DependenciesPicker
          id="dependencies-manager-dependents"
          label="Dependents"
          serviceMapId=""
          nodes={nodes}
          value={dependents}
          onChange={onDependentsChange}
          width="100%"
          disableNew
        />
      </Stack>
    </Card>
  );
};
